import * as types from '@store/types'
import { getInformation, getCampaigns } from './search-campaigns'
import store from '@store'
import equals from 'deep-equal'
import Campaigns from '@queries/Campaigns'
import request from '@queries'

const state = {
  info: {
    quantity: 0,
    icon: 'box2',
    type: 'every',
    title: 'Principais Parceiros'
  },
  term: '',
  options: {
    page: 0
  },
  results: {},
  suggestions: []
}

const getters = {
  [types.SEARCH_INFO]: (state) => state.info,

  [types.SEARCH_TERM]: (state) => state.term,

  [types.SEARCH_OPTIONS]: (state) => state.options,

  [types.SEARCH_RESULTS]: (state, getters) => {
    const isSearchTermPage = ('query' in state.options) && !('favorites' in state.options)

    const results = state ? state.results : []

    const favorites = getters[types.FAVORITES] || []

    const campaigns = results.length > 0
      ? results.map(
        (campaign) => ({
          ...campaign,
          is_favorited: favorites.includes(campaign.slug)
        })
      )
      : []

    return isSearchTermPage ? campaigns : results
  },

  [types.SEARCH_SUGGESTIONS]: (state) => {
    if (state.term === '') { return [] }
    return state.suggestions
  }
}

const mutations = {
  [types.SEARCH_INFO]: (state, payload) => {
    state.info = payload
  },

  [types.SEARCH_TERM]: (state, payload) => {
    state.term = payload
  },

  [types.SEARCH_TERM_CLEAR]: (state, payload) => {
    state.term = ''
  },

  [types.SEARCH_OPTIONS]: (state, payload) => {
    state.options = payload
  },

  [types.SEARCH_RESULTS]: (state, payload) => {
    state.results = payload
  },

  [types.SEARCH_SUGGESTIONS]: (state, payload) => {
    state.suggestions = payload
  },

  [types.SEARCH_FAVORITE_ADD]: (state, searchedSlug) => {
    const index = state.results.findIndex(result => result.slug === searchedSlug)
    state.results[index].is_favorited = true
  },

  [types.SEARCH_FAVORITE_REMOVE]: (state, searchedSlug) => {
    const isFavoriteRouter = state.options.favorites
    const index = state.results.findIndex(result => result.slug === searchedSlug)
    state.results[index].is_favorited = false
    if (isFavoriteRouter) { state.results.splice(index, 1) }
  }
}

const actions = {
  [types.SEARCH_CAMPAIGNS]: async ({ commit, getters }, payload = {}) => {
    const { options, breadcrumb_names, search_info } = payload

    const { data } = await request(Campaigns, options)
    // Corrige o problema de assíncronia nos resultados onde o resultado exibido
    // não é a última pesquisa do usuário.
    const currentOptions = getters[types.SEARCH_OPTIONS]

    if (!equals(options, currentOptions)) return true

    commit(types.IS_FETCHING_CAMPAIGNS, false)
    commit(types.BREADCRUMB_NAMES, breadcrumb_names)
    commit(types.SEARCH_RESULTS, data.data.campaigns.data)
    commit(types.SEARCH_INFO, {
      ...search_info,
      quantity: data.data.campaigns.total
    })
  },
  [types.SEARCH]: async ({ commit, getters, dispatch }, payload = {}) => {
    const query = payload.query || ''

    // Busca das categorias do menu
    if (payload.category) {
      const categories = getters[types.CATEGORIES]

      const category = categories.find(category =>
        category.slug === payload.category
      )

      const orderOptions = [
        { name: 'asc', value: !!payload.alphabetical },
        { name: 'desc', value: !!payload.alphainverse },
        { name: 'value', value: !!payload.discount },
        { name: 'likes', value: !!payload.likes }
      ]

      const orderBy = orderOptions.find(el => el.value)
      const categoryID = (category && category.id) ? category.id : ''
      const options = {
        category: categoryID,
        page: payload.page || 1,
        limit: 18,
        exclusive: payload.exclusive || null,
        cashback: payload.cashback || null,
        orderBy: (orderBy || {}).name
      }
      // parte que não vai mudar (muito)
      commit(types.IS_FETCHING_CAMPAIGNS, true)
      commit(types.SEARCH_TERM, query)
      commit(types.SEARCH_OPTIONS, options)

      const breadcrumbNames = category ? { '/campanhas': category.name } : null
      const icon = category && category.icon ? category.icon : ''
      const title = category && category.name ? category.name : ''
      const searchInfo = {
        icon,
        title
      }

      return await dispatch('search/SEARCH_CAMPAIGNS', ({ commit, getters }, {
        options,
        breadcrumb_names: breadcrumbNames,
        search_info: searchInfo
      }))
    } else if (payload.highlight) {
      const options = {
        page: payload.page || 1,
        limit: 10,
        highlight: '1'
      }

      commit(types.IS_FETCHING_CAMPAIGNS, true)
      commit(types.SEARCH_TERM, query)
      commit(types.SEARCH_OPTIONS, options)

      const info = await getInformation(options)
      const breadcrumbNames = { '/campanhas': info.title }
      const searchInfo = {
        ...info
      }
      return await dispatch('search/SEARCH_CAMPAIGNS', ({ commit, getters }, {
        options,
        breadcrumb_names: breadcrumbNames,
        search_info: searchInfo
      }))
    } else if (payload.tag) {
      const options = {
        page: payload.page || 1,
        tags: payload.tag,
        limit: 10
      }

      commit(types.IS_FETCHING_CAMPAIGNS, true)
      commit(types.SEARCH_TERM, query)
      commit(types.SEARCH_OPTIONS, options)

      const info = await getInformation(options)
      const breadcrumbNames = { '/campanhas': info.title }
      const searchInfo = {
        ...info
      }
      return await dispatch('search/SEARCH_CAMPAIGNS', ({ commit, getters }, {
        options,
        breadcrumb_names: breadcrumbNames,
        search_info: searchInfo
      }))
    } else {
      // Busca Geral

      const options = {
        ...payload,
        company: getters[types.AUTH].company,
        query: query || undefined,
        page: +!!payload.favorites
      }

      commit(types.IS_FETCHING_CAMPAIGNS, true)
      commit(types.SEARCH_TERM, query)
      commit(types.SEARCH_OPTIONS, options)

      const { quantity, campaigns } = await getCampaigns(options)
      const info = await getInformation(options)

      // Corrige o problema de assíncronia nos resultados onde o resultado exibido
      // não é a última pesquisa do usuário.
      const currentOptions = store.getters[types.SEARCH_OPTIONS]

      if (!equals(options, currentOptions)) return

      commit(types.IS_FETCHING_CAMPAIGNS, false)
      commit(types.BREADCRUMB_NAMES, { '/campanhas': info.title })
      commit(types.SEARCH_RESULTS, campaigns)
      commit(types.SEARCH_INFO, {
        ...info,
        quantity
      })
    }
  },

  [types.SEARCH_SUGGESTIONS]: async ({ commit, getters }, payload) => {
    const query = payload.query || ''
    const cancel = payload.cancel
    const { company } = getters[types.AUTH]

    commit(types.SEARCH_TERM, query)

    if (!query) {
      commit(types.SEARCH_SUGGESTIONS, [])
      return
    }

    const { campaigns } = await getCampaigns({
      company,
      query,
      quantity: 3,
      cancel
    })

    commit(types.SEARCH_SUGGESTIONS, [...campaigns])
  },

  [types.SEARCH_INCREASE]: async ({ commit, getters }) => {
    const { quantity } = getters[types.SEARCH_INFO]
    const campaigns = getters[types.SEARCH_RESULTS]

    if (campaigns.length >= quantity) return true

    let options = getters[types.SEARCH_OPTIONS]

    options = {
      ...options,
      page: options.page + 1
    }

    commit(types.SEARCH_OPTIONS, options)

    if (!options.query) {
      const { data } = await request(Campaigns, options)
      const campaignData = data && data.data && data.data.campaigns && data.data.campaigns.data ? data.data.campaigns.data : []

      commit(types.SEARCH_RESULTS, [
        ...campaigns,
        ...campaignData
      ])

      return
    }

    const results = await getCampaigns(options)

    commit(types.SEARCH_RESULTS, [...campaigns, ...results.campaigns])
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/search.js